import { PUSH_DATA } from '../actionTypes'

export const pushData = (payload: object) => ({ type: PUSH_DATA, payload })
